import React from 'react';
import logo from 'images/cmlinsight-logo.png';

const CompanyLogo = ({ width }) => {
  return <img src={logo} alt="cml-logo" width={width} />;
};

export default CompanyLogo;
